import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { RotatingLines } from "react-loader-spinner";
import { useNavigate } from "react-router-dom";
import Constants from "../Constants";
import APIUrls from "../services/APIUrls";
import { getAxiosResponse } from "../services/authApiRoutes/APImethods";
import AppErrorPage from "./AppErrorPage";

export default function EmailVerification() {

    const navigate = useNavigate();
    const { t } = useTranslation();
     const translate = t;

    const [showLoader, setShowLoader] = useState(true);
    const [showError, setShowError] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        getAxiosResponse(APIUrls.NEW_EMAIL_VALIDATION + window.location.search)
        .then((res) => {
            if(res?.data?.status !== Constants.FAILURE) {
                setShowLoader(false);
                let redirectUrl = res?.data?.data?.url.replace("/cust.htm#", "/");
                let msg = Constants.BLANK;
                let status = Constants.SUCCESS;
                if(redirectUrl.includes("/eu")) {
                    msg = translate("email_verification.success");
                } else if(redirectUrl.includes("/eiu")) {
                    msg = translate("email_verification.email_in_use");
                    status = Constants.ERROR;
                } else {
                    msg = translate("email_verification.failure");
                    status = Constants.ERROR;
                }
                navigate(redirectUrl, {
                    state: {
                        message: msg,
                        status: status,
                    },
                });
            } else {
                setShowLoader(false);
                setShowError(true);
                setError(res?.data?.message);
            }
        })
        .catch((err) => {
            console.error(err);
        });
    }, [])

    return (
        <div style={{ textAlign: "center" }}>
            {showLoader && <RotatingLines
            strokeColor="grey"
            strokeWidth="5"
            width="96"
            visible={showLoader}
            />}
            {showError && <AppErrorPage errorMsg={error}/>}
        </div>
    )
}